
<div>
  <icon-list v-if="isChildCare" :items="ageGroupDisplay" iconColor="#4B4C52" :customMargin="16" />
  <tag-label-group v-else-if="isPetCare" :items="petExperienceDisplay" />
  <tag-label-group v-else-if="isHousekeeping" :items="serviceExperienceDisplay" />
  <div v-else-if="isCompanionCare">
    <checkmark-list v-if="ageGroupsExperience" :tips="companionCareAgeGroupDisplay" />
    <tag-label-group
      v-if="basicCareServicesExperience"
      :items="basicServicesExperienceDisplay"
      title="Basic services"
      class="mt-16"
    />
    <tag-label-group
      v-if="personalCareServicesExperience"
      :items="personalServicesExperienceDisplay"
      title="Personal services"
      class="mt-16"
    />
  </div>
</div>
